import React, { useEffect } from "react";
import { Button, Space, Switch, Table, Upload, message } from "antd";
import { useHistory } from "react-router";
import { goPage } from "../../layout/pageDefinition";
import { useModel } from "../../../models";
import SupplierService from "./SupplierService.js"
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

export default function () {
    const [{ supplierTypeDict }, { getSupplierTypeDict }] = useModel("cmDict");
    const [
        { searchParam, supplierList, selectedSupplier, pageInfo, selectedSupplierRowKeys },
        { loadSupplierList, setSearchParam, setSelectedSupplier, setSelectedSupplierRowKeys, enableOrDisableSupplier }
    ] = useModel("supplier");
    useEffect(() => {
        getSupplierTypeDict()
        loadSupplierList({ showMsg: false, data: {} });
        setSearchParam({})
    }, [])
    const history = useHistory();
    const onAdd = () => {
        goPage(history, "6-3-2");
    }
    const onEdit = () => {
        let findCustomerList = supplierList.find(item => {
            if (item.key === selectedSupplier.key) {
                return item
            }
        })
        setSelectedSupplier(findCustomerList)
        setSelectedSupplierRowKeys([findCustomerList.key]);
        goPage(history, "6-3-1");
    }

    const onExport = async () => {
        let { pageNum, pageSize } = pageInfo
        let res = {
            type: "post",
            data: {
                ...searchParam,
                pageSize,
                pageNum
            }
        }
        await SupplierService.export(res);
    }
    const onDownloadTpl = async () => {
        await SupplierService.downloadTpl();

    }
    const onPageChange = (page, pageSize) => {
        const params = { ...searchParam };
        params.pageNum = page;
        params.pageSize = pageSize;
        loadSupplierList({ showMsg: false, data: params });
    }
    //启用、禁用
    const onDisabled = (record, checked) => {
        enableOrDisableSupplier({ showMsg: true, data: { record, checked } })
    }


    const columns = [
        {
            title: '序号',
            width: 50,
            render: (text, record, index) => `${index + 1}`,
        },
        {
            title: '供应商编码',
            dataIndex: 'supplierCode',
            width: 200,
            align: 'left',
        },
        {
            title: '供应商类型',
            dataIndex: 'supplierType',
            width: 150,
            render: (text, record) => {
                return (
                    <span>
                        {
                            supplierTypeDict.map((item) => {
                                if (item.key == text) {
                                    return item.label
                                }
                            })
                        }
                    </span>
                )
            }
        },
        {
            title: '供应商名称',
            dataIndex: 'supplierName',
            width: 250
        },
        {
            title: '联系人',
            dataIndex: 'supplierPerson',
            width: 100
        },
        {
            title: '联系电话',
            dataIndex: 'supplierPhone',
            width: 150
        },
        {
            title: '地址',
            dataIndex: 'supplierAddress',
            width: 320
        },
        {
            title: '办公电话',
            dataIndex: 'supplierTelephone',
            width: 150
        },
        {
            title: '传真',
            dataIndex: 'supplierFax',
            width: 150
        },
        {
            title: '邮箱',
            dataIndex: 'supplierEmail',
            width: 180
        },
        {
            title: '所属公司',
            dataIndex: 'orgName',
            width: 150,
            ellipsis: true
        },
        {
            title: '创建人',
            dataIndex: 'createUser',
            ellipsis: true,
            width: 150,
        },
        {
            title: '登记时间',
            width: 150,
            dataIndex: 'createTime',
        },
        {
            title: '状态',
            dataIndex: 'supplierStatus',
            width: 100,
            render: (text, record) => <Space size="middle" onClick={e => e.stopPropagation()}>
                <Switch
                    checked={record.supplierStatus === 0}
                    onChange={checked => {
                        onDisabled(record, checked);
                    }}
                    size="small" />
            </Space>,
        },
        {
            title: '备注',
            dataIndex: 'supplierDesc',
            width: 150,
            ellipsis: true,
        },


    ];
    const onUploadSuccess = (retData) => {
        let data = {
            "pageSize": 15,
            "pageNum": 1
        }
        loadSupplierList({ showMsg: false, data });
    }

    return (
        <>
            <div style={{ margin: "12px 0" }}>
                <YhAuth resCode={ResourceAuthEnum.DATA_S_AD}>
                    <Button type="primary" onClick={onAdd}>新增</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_S_ED}>
                    <Button className="margin-left-8" disabled={!!!selectedSupplier} onClick={onEdit}>编辑</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_S_IM}>
                    <Upload {...SupplierService.getImportCfg({ onUploadSuccess })}>
                        <Button className="margin-left-8">导入</Button>
                    </Upload>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_S_EX}>
                    <Button className="margin-left-8" onClick={onExport}>导出</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_S_DLOAD}>
                    <Button className="margin-left-8" onClick={onDownloadTpl}>下载模板</Button>
                </YhAuth>
            </div>
            <Table
                columns={columns}
                dataSource={supplierList}
                bordered
                pagination={{
                    hideOnSinglePage: false,
                    showSizeChanger: true,
                    defaultCurrent: 1,
                    defaultPageSize: 15,
                    onChange: onPageChange,
                    total: pageInfo.total,
                    current: pageInfo.pageNum,
                    pageSizeOptions: [15, 50, 100, 200, 500],
                }}
                onRow={record => {
                    return {
                        onClick: event => {
                            if (selectedSupplier && selectedSupplier.key === record.key) {
                                setSelectedSupplier(null);
                                setSelectedSupplierRowKeys([]);
                            } else {
                                setSelectedSupplier(record);
                                setSelectedSupplierRowKeys([record.key]);
                            }
                        },
                    };
                }}
                rowSelection={{
                    type: "radio",
                    onChange: (selectedRowKeys, selectedRows) => {
                        setSelectedSupplier(selectedRows[0])
                        setSelectedSupplierRowKeys(selectedRowKeys);
                    },

                    getCheckboxProps: record => ({
                        disabled: record.name === 'Disabled User',
                        name: record.name,
                    }),
                    selectedRowKeys: selectedSupplierRowKeys
                }}
                scroll={{ x: 'max-content' }}
            />
        </>
    );
}